import { Route } from '@angular/router';
import { FacultyQueuesComponent } from './faculty-queues.component';
import { UserRouteAccessService } from '../../services';

export const FACULTY_QUEUES_ROUTE: Route = {
    path: 'faculty-queues-state/:id',
    component: FacultyQueuesComponent,
    data: {
        pageTitle: 'global.title'
    },
    canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/faculty-queues/faculty-queues.route.ts